module.exports = __webpack_public_path__ + "img/電気回路_5_5_3.19e276bd.png";